@if (!variant) {
  <ng-container *ngIf="type === 'flat'">
    <button
      mat-flat-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color"
      [disabled]="disabled || loading"
      [ngClass]="{ 'cursor-not-allowed': disabled || loading }"
      class="ts-button icon-position-{{ iconPosition }}"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="type === 'raised'">
    <button
      mat-raised-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color"
      [disabled]="disabled || loading"
      [ngClass]="{ 'cursor-not-allowed': disabled || loading }"
      class="ts-button icon-position-{{ iconPosition }}"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="type === 'stroked'">
    <button
      mat-stroked-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color"
      [disabled]="disabled || loading"
      [ngClass]="{ 'cursor-not-allowed': disabled || loading }"
      class="ts-button icon-position-{{ iconPosition }} bg-white"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="type === 'icon'">
    <button
      mat-icon-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color"
      [disabled]="disabled || loading"
      [ngClass]="{ 'cursor-not-allowed': disabled || loading }"
      [matTooltip]="iconTooltip"
    >
      @if (lucideIcon) {
        <lucide-icon [name]="icon" [size]="16" color="black" [class]="iconCssClass"></lucide-icon>
      } @else {
        <ts-icon [icon]="icon" [color]="iconColor" [class]="iconCssClass"></ts-icon>
      }
    </button>
  </ng-container>
} @else {
  @switch (variant) {
    @case ('secondary') {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        mat-stroked-button
        class="bg-white ts-button icon-position-{{ iconPosition }}"
        color="accent"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ 'bg-gray-200': disabled, active: active, 'cursor-not-allowed': disabled || loading }"
        [disabled]="disabled || loading"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @case ('danger') {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        mat-flat-button
        class="ts-button icon-position-{{ iconPosition }}"
        color="warn"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active, 'cursor-not-allowed': disabled || loading }"
        [disabled]="disabled || loading"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @case ('link') {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        type="button"
        class="ts-button ts-button--link icon-position-{{ iconPosition }}"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active, 'cursor-not-allowed': disabled || loading }"
        [disabled]="disabled || loading"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @case ('dashed') {
      <button
        TSDebounceClick
        type="button"
        class="ts-button ts-button--dashed icon-position-{{ iconPosition }}"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active, 'cursor-not-allowed': disabled || loading }"
        [disabled]="disabled || loading"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @default {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        mat-flat-button
        class="ts-button icon-position-{{ iconPosition }}"
        color="primary"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active }"
        [disabled]="disabled || loading"
        [ngClass]="{ 'cursor-not-allowed': disabled || loading }"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
  }
}

<ng-template #buttonContent>
  <div class="flex flex-row items-center justify-between gap-2 h-full">
    @if (loading) {
      <mat-spinner diameter="16" class="mr-2" [strokeWidth]="2" mode="indeterminate" [color]="color"></mat-spinner>
      <ng-container [ngTemplateOutlet]="buttonText"></ng-container>
    } @else {
      @if (icon) {
        @if (lucideIcon) {
          <lucide-icon [name]="icon" [size]="16" color="black" [class]="iconCssClass" />
        } @else {
          <ts-icon [icon]="icon" [color]="iconColor" />
        }
      }
      <ng-container [ngTemplateOutlet]="buttonText"></ng-container>
      @if (menuIcon) {
        <div
          class="icon-position-suffix__container"
          [ngClass]="{ 'icon-position-suffix__container--secondary': variant === 'secondary' }"
        >
          <ts-icon icon="keyboard_arrow_down" [color]="iconColor"></ts-icon>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #buttonText>
  <ng-content></ng-content>
</ng-template>
